'use client';

import { useState, useRef, useEffect } from 'react';

// Filter options
const propertyTypes = [
    { value: "1", label: 'Villa' },
    { value: "2", label: 'Office Space' },
    { value: "3", label: 'Apartment' },
    { value: "4", label: 'Farmhouse' },
    { value: "5", label: 'Independent House' },
    { value: "7", label: 'PG/Hostel' },
    { value: "9", label: 'Warehouse' },
];

const facingOptions = [
    { value: 'east', label: 'East' },
    { value: 'west', label: 'West' },
    { value: 'north', label: 'North' },
    { value: 'south', label: 'South' },
    { value: 'north,east', label: 'North-East' },
    { value: 'north,west', label: 'North-West' },
    { value: 'south,east', label: 'South-East' },
    { value: 'south,west', label: 'South-West' },
];
const bhkOptions = [
    { value: '1', label: '1 BHK' },
    { value: '2', label: '2 BHK' },
    { value: '3', label: '3 BHK' },
    { value: '4', label: '4 BHK' },
    { value: '5+', label: '5+ BHK' },
];

const postedByOptions = [
    { value: 'owner', label: 'Owner' },
    { value: 'agent', label: 'Agent/Broker' },
    { value: 'builder', label: 'Builder' },
];

const furnishingOptions = [
    { value: 'furnished', label: 'Fully Furnished' },
    { value: 'semi', label: 'Semi Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
];

const statusOptions = [
    { value: 'active', label: 'Ready to Move' },
    { value: 'pending', label: 'Available Later' },
];

const budgetRanges = {
    buy: [
        { min: 0, max: 30, label: 'Under ₹30 Lac' },
        { min: 30, max: 50, label: '₹30-50 Lac' },
        { min: 50, max: 75, label: '₹50-75 Lac' },
        { min: 75, max: 100, label: '₹75 Lac - ₹1 Cr' },
        { min: 100, max: 200, label: '₹1-2 Cr' },
        { min: 200, max: null, label: 'Above ₹2 Cr' },
    ],
    rent: [
        { min: 0, max: 10000, label: 'Under ₹10K' },
        { min: 10000, max: 20000, label: '₹10K-20K' },
        { min: 20000, max: 35000, label: '₹20K-35K' },
        { min: 35000, max: 50000, label: '₹35K-50K' },
        { min: 50000, max: null, label: 'Above ₹50K' },
    ],
    projects: [
        { min: 0, max: 40, label: 'Under ₹40 Lac' },
        { min: 40, max: 70, label: '₹40-70 Lac' },
        { min: 70, max: 100, label: '₹70 Lac - ₹1 Cr' },
        { min: 100, max: 200, label: '₹1-2 Cr' },
        { min: 200, max: 500, label: '₹2-5 Cr' },
        { min: 200, max: 500, label: '₹2-5 Cr' },
        { min: 500, max: null, label: 'Above ₹5 Cr' },
    ],
    plots: [
        { min: 0, max: 10, label: 'Under ₹10 Lac' },
        { min: 10, max: 25, label: '₹10-25 Lac' },
        { min: 25, max: 50, label: '₹25-50 Lac' },
        { min: 50, max: 100, label: '₹50 Lac - ₹1 Cr' },
        { min: 100, max: 300, label: '₹1-3 Cr' },
        { min: 300, max: null, label: 'Above ₹3 Cr' },
    ],
    civil: [
        { min: 0, max: 5000, label: 'Under ₹5,000' },
        { min: 5000, max: 20000, label: '₹5,000 - ₹20,000' },
        { min: 20000, max: 50000, label: '₹20,000 - ₹50,000' },
        { min: 50000, max: 100000, label: '₹50,000 - ₹1 Lakh' },
        { min: 100000, max: null, label: 'Above ₹1 Lakh' },
    ],
};

const tenantPreferenceOptions = [
    { value: 'bachelor', label: 'Bachelors' },
    { value: 'family', label: 'Family' },
    { value: 'company', label: 'Company' },
];

const availabilityOptions = [
    { value: 'immediate', label: 'Immediate' },
    { value: '15_days', label: 'Within 15 Days' },
    { value: '30_days', label: 'Within 30 Days' },
];

const plotTypeOptions = [
    { value: "6", label: 'Plot' },
    { value: "8", label: 'Industrial Land' },
    { value: "10", label: 'Agricultural Land' },
];

const plotSizeOptions = [
    { value: '0-1000', label: 'Under 1000 sq.ft' },
    { value: '1000-2000', label: '1000-2000 sq.ft' },
    { value: '2000-3000', label: '2000-3000 sq.ft' },
    { value: '3000-5000', label: '3000-5000 sq.ft' },
    { value: '5000-10000', label: '5000-10000 sq.ft' },
    { value: '10000+', label: 'Above 10000 sq.ft' },
];

const civilServiceOptions = [
    { value: 'painting', label: 'Painting' },
    { value: 'plumbing', label: 'Plumbing' },
    { value: 'electrical', label: 'Electrical' },
    { value: 'carpentry', label: 'Carpentry' },
    { value: 'masonry', label: 'Masonry' },
    { value: 'renovation', label: 'Renovation' },
    { value: 'interior', label: 'Interior Design' },
];

const experienceOptions = [
    { value: '1-3', label: '1-3 Years' },
    { value: '3-5', label: '3-5 Years' },
    { value: '5+', label: '5+ Years' },
];

const approvalOptions = [
    { value: 'cmda', label: 'CMDA Approved' },
    { value: 'dtcp', label: 'DTCP Approved' },
    { value: 'rera', label: 'RERA Registered' },
    { value: 'panchayat', label: 'Panchayat Approved' },
];

const FilterDropdown = ({ title, active, onClick, children, count }) => {
    const hasCount = count > 0;
    return (
        <div className="relative">
            <button
                onClick={onClick}
                className={`flex items-center gap-2 px-5 py-2.5 text-sm font-medium transition-all duration-300 ${active || hasCount
                    ? 'border-primary text-primary transform -translate-y-0.5'
                    : 'border-slate-200 bg-white text-slate-600 hover:border-primary/50 hover:text-primary'
                    }`}
            >
                {title}
                {hasCount && (
                    <span className="flex items-center justify-center min-w-[20px] h-5 px-1.5 ml-1 text-xs font-bold text-white bg-primary rounded-full">
                        {count}
                    </span>
                )}
                <svg
                    className={`w-4 h-4 transition-transform duration-300 ${active ? 'rotate-180' : ''} ${active || hasCount ? 'text-primary' : 'text-slate-400'}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            {active && (
                <div className="absolute top-full left-0 mt-1 w-72 bg-white shadow-xl hover:shadow-2xl border border-slate-100 p-5 z-50 animate-fadeInUp origin-top-left ring-1 ring-black/5">
                    {children}
                </div>
            )}
        </div>
    );
};

const HorizontalFilterBar = ({
    filters = {},
    onChange,
    listingType = 'buy',
}) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [localFilters, setLocalFilters] = useState(filters);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = (name) => {
        setOpenDropdown(openDropdown === name ? null : name);
    };

    const handleFilterChange = (key, value) => {
        const newFilters = { ...localFilters };

        // Handle array-based filters
        if (Array.isArray(newFilters[key])) {
            if (newFilters[key].includes(value)) {
                newFilters[key] = newFilters[key].filter(v => v !== value);
            } else {
                newFilters[key] = [...newFilters[key], value];
            }
        } else {
            newFilters[key] = value;
        }

        setLocalFilters(newFilters);
        if (onChange) onChange(newFilters);
    };

    const toggleArrayFilter = (key, value) => {
        const current = localFilters[key] || [];
        const updated = current.includes(value)
            ? current.filter(v => v !== value)
            : [...current, value];

        const newFilters = { ...localFilters, [key]: updated };
        setLocalFilters(newFilters);
        if (onChange) onChange(newFilters);
    };

    const clearFilters = () => {
        setLocalFilters({});
        if (onChange) onChange({});
        setOpenDropdown(null);
    };

    const activeFilterCount = Object.values(localFilters).filter(
        v => v && (Array.isArray(v) ? v.length > 0 : true)
    ).length;

    return (
        <div ref={dropdownRef} className="w-full bg-white transition-all sticky top-200 duration-300">
            <div className="container-custom">
                <div className="py-1">
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        {/* Property Type (Hidden for Civil) */}
                        {listingType !== 'civil' && listingType !== 'plots' && (
                            <FilterDropdown
                                title="Property Type"
                                active={openDropdown === 'propertyType'}
                                onClick={() => toggleDropdown('propertyType')}
                                count={(localFilters.propertyType || []).length}
                            >
                                <div className="space-y-2">
                                    {propertyTypes.map((type) => (
                                        <label key={type.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.propertyType || []).includes(type.value)}
                                                onChange={() => toggleArrayFilter('propertyType', type.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{type.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}


                        {/* FACINGS */}
                        {listingType !== 'civil' && (
                            <FilterDropdown
                                title="Facing"
                                active={openDropdown === 'facing'}
                                onClick={() => toggleDropdown('facing')}
                                count={(localFilters.facing || []).length}
                            >
                                <div className="space-y-2">
                                    {facingOptions.map((facing) => (
                                        <label key={facing.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.facing || []).includes(facing.value)}
                                                onChange={() => toggleArrayFilter('facing', facing.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{facing.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Service Type (For Civil Only) */}
                        {listingType === 'civil' && (
                            <FilterDropdown
                                title="Service Type"
                                active={openDropdown === 'serviceType'}
                                onClick={() => toggleDropdown('serviceType')}
                                count={(localFilters.serviceType || []).length}
                            >
                                <div className="space-y-2">
                                    {civilServiceOptions.map((type) => (
                                        <label key={type.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.serviceType || []).includes(type.value)}
                                                onChange={() => toggleArrayFilter('serviceType', type.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{type.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Experience (For Civil Only) */}
                        {listingType === 'civil' && (
                            <FilterDropdown
                                title="Experience"
                                active={openDropdown === 'experience'}
                                onClick={() => toggleDropdown('experience')}
                                count={(localFilters.experience || []).length}
                            >
                                <div className="space-y-2">
                                    {experienceOptions.map((exp) => (
                                        <label key={exp.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.experience || []).includes(exp.value)}
                                                onChange={() => toggleArrayFilter('experience', exp.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{exp.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* BHK (Hidden for Civil and Plots) */}
                        {listingType !== 'civil' && listingType !== 'plots' && (
                            <FilterDropdown
                                title="BHK"
                                active={openDropdown === 'bhk'}
                                onClick={() => toggleDropdown('bhk')}
                                count={(localFilters.bhk || []).length}
                            >
                                <div className="space-y-2">
                                    {bhkOptions.map((bhk) => (
                                        <label key={bhk.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.bhk || []).includes(bhk.value)}
                                                onChange={() => toggleArrayFilter('bhk', bhk.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{bhk.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Plot Type (For Plots Only) */}
                        {listingType === 'plots' && (
                            <FilterDropdown
                                title="Plot Type"
                                active={openDropdown === 'plotType'}
                                onClick={() => toggleDropdown('plotType')}
                                count={(localFilters.plotType || []).length}
                            >
                                <div className="space-y-2">
                                    {plotTypeOptions.map((opt) => (
                                        <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.plotType || []).includes(opt.value)}
                                                onChange={() => toggleArrayFilter('plotType', opt.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{opt.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Plot Size (For Plots Only) */}
                        {listingType === 'plots' && (
                            <FilterDropdown
                                title="Plot Size"
                                active={openDropdown === 'plotSize'}
                                onClick={() => toggleDropdown('plotSize')}
                                count={(localFilters.plotSize || []).length}
                            >
                                <div className="space-y-2">
                                    {plotSizeOptions.map((opt) => (
                                        <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.plotSize || []).includes(opt.value)}
                                                onChange={() => toggleArrayFilter('plotSize', opt.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{opt.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Budget */}
                        <FilterDropdown
                            title="Budget"
                            active={openDropdown === 'budget'}
                            onClick={() => toggleDropdown('budget')}
                            count={localFilters.budgetMin !== undefined ? 1 : 0}
                        >
                            <div className="space-y-2">
                                {budgetRanges[listingType].map((range, idx) => (
                                    <label key={idx} className="flex items-center gap-3 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="budget"
                                            checked={localFilters.budgetMin === range.min && localFilters.budgetMax === range.max}
                                            onChange={() => {
                                                const newFilters = {
                                                    ...localFilters,
                                                    budgetMin: range.min,
                                                    budgetMax: range.max
                                                };
                                                setLocalFilters(newFilters);
                                                if (onChange) onChange(newFilters);
                                            }}
                                            className="w-4 h-4 text-primary border-gray-300 focus:ring-primary"
                                        />
                                        <span className="text-sm text-gray-700">{range.label}</span>
                                    </label>
                                ))}
                            </div>
                        </FilterDropdown>

                        {/* Approvals (For Plots Only) */}
                        {listingType === 'plots' && (
                            <FilterDropdown
                                title="Approvals"
                                active={openDropdown === 'approval'}
                                onClick={() => toggleDropdown('approval')}
                                count={(localFilters.approval || []).length}
                            >
                                <div className="space-y-2">
                                    {approvalOptions.map((opt) => (
                                        <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.approval || []).includes(opt.value)}
                                                onChange={() => toggleArrayFilter('approval', opt.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{opt.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Posted By (For Plots Only) */}
                        {listingType === 'plots' && (
                            <FilterDropdown
                                title="Posted By"
                                active={openDropdown === 'postedBy'}
                                onClick={() => toggleDropdown('postedBy')}
                                count={(localFilters.postedBy || []).length}
                            >
                                <div className="space-y-2">
                                    {postedByOptions.map((opt) => (
                                        <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={(localFilters.postedBy || []).includes(opt.value)}
                                                onChange={() => toggleArrayFilter('postedBy', opt.value)}
                                                className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                            />
                                            <span className="text-sm text-gray-700">{opt.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </FilterDropdown>
                        )}

                        {/* More Filters Dropdown (Hidden for Plots and Civil) */}
                        {listingType !== 'plots' && listingType !== 'civil' && (
                            <FilterDropdown
                                title="More Filters"
                                active={openDropdown === 'more'}
                                onClick={() => toggleDropdown('more')}
                                count={
                                    (localFilters.furnishing || []).length +
                                    (localFilters.tenantPreference || []).length +
                                    (localFilters.availability || []).length +
                                    (localFilters.status || []).length +
                                    (localFilters.postedBy || []).length
                                }
                            >
                                <div className="space-y-4 max-h-64 overflow-y-auto pr-2">
                                    {/* Furnishing */}
                                    <div>
                                        <h5 className="text-xs font-semibold text-gray-500 uppercase mb-2">Furnishing</h5>
                                        <div className="space-y-2">
                                            {furnishingOptions.map((opt) => (
                                                <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={(localFilters.furnishing || []).includes(opt.value)}
                                                        onChange={() => toggleArrayFilter('furnishing', opt.value)}
                                                        className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                                    />
                                                    <span className="text-sm text-gray-700">{opt.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Tenant Preference - Rent Only */}
                                    {listingType === 'rent' && (
                                        <div>
                                            <h5 className="text-xs font-semibold text-gray-500 uppercase mb-2 mt-4">Tenant Preference</h5>
                                            <div className="space-y-2">
                                                {tenantPreferenceOptions.map((opt) => (
                                                    <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            checked={(localFilters.tenantPreference || []).includes(opt.value)}
                                                            onChange={() => toggleArrayFilter('tenantPreference', opt.value)}
                                                            className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                                        />
                                                        <span className="text-sm text-gray-700">{opt.label}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Availability - Rent Only */}
                                    {listingType === 'rent' && (
                                        <div>
                                            <h5 className="text-xs font-semibold text-gray-500 uppercase mb-2 mt-4">Availability</h5>
                                            <div className="space-y-2">
                                                {availabilityOptions.map((opt) => (
                                                    <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            checked={(localFilters.availability || []).includes(opt.value)}
                                                            onChange={() => toggleArrayFilter('availability', opt.value)}
                                                            className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                                        />
                                                        <span className="text-sm text-gray-700">{opt.label}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Status - Buy & Projects */}
                                    {(listingType === 'buy' || listingType === 'projects') && (
                                        <div>
                                            <h5 className="text-xs font-semibold text-gray-500 uppercase mb-2 mt-4">Status</h5>
                                            <div className="space-y-2">
                                                {statusOptions.map((opt) => (
                                                    <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            checked={(localFilters.status || []).includes(opt.value)}
                                                            onChange={() => toggleArrayFilter('status', opt.value)}
                                                            className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                                        />
                                                        <span className="text-sm text-gray-700">{opt.label}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Posted By */}
                                    <div>
                                        <h5 className="text-xs font-semibold text-gray-500 uppercase mb-2 mt-4">Posted By</h5>
                                        <div className="space-y-2">
                                            {postedByOptions.map((opt) => (
                                                <label key={opt.value} className="flex items-center gap-3 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={(localFilters.postedBy || []).includes(opt.value)}
                                                        onChange={() => toggleArrayFilter('postedBy', opt.value)}
                                                        className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-primary"
                                                    />
                                                    <span className="text-sm text-gray-700">{opt.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </FilterDropdown>
                        )}

                        {/* Verified Toggle */}
                        {/* <div className="h-10 w-[1px] bg-gray-200 mx-2 hidden md:block"></div>

                        <label className="flex items-center gap-2 cursor-pointer select-none">
                            <div className="relative">
                                <input
                                    type="checkbox"
                                    checked={localFilters.verifiedOnly || false}
                                    onChange={(e) => {
                                        const newFilters = { ...localFilters, verifiedOnly: e.target.checked };
                                        setLocalFilters(newFilters);
                                        if (onChange) onChange(newFilters);
                                    }}
                                    className="sr-only"
                                />
                                <div className={`w-10 h-6 rounded-full transition-colors ${localFilters.verifiedOnly ? 'bg-primary' : 'bg-gray-200'}`}>
                                    <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${localFilters.verifiedOnly ? 'translate-x-4' : 'translate-x-0'}`} />
                                </div>
                            </div>
                            <span className="text-sm font-medium text-gray-700">Verified</span>
                        </label> */}

                        {/* Clear Button */}
                        <button
                            onClick={clearFilters}
                            disabled={activeFilterCount === 0}
                            className="text-sm text-red-500 font-medium hover:underline ml-10 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Clear All
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HorizontalFilterBar;
